<div class="flex layout-row place-start-center gap-md">
  <div class="layout-col p-xs">
    <elder-search-box dense [elderSearchContext]="data?.filter"></elder-search-box>
  </div>

  <div class="layout-col">
    <elder-chip-list-select
      [data]="involvedProcessPlans$ | async"
      [idField]="'id'"
      [displayField]="'name'"
      [selectionMultiEnabled]="true"
      (selectionChange)="updateProcessPlanFilters($event)"
    >
    </elder-chip-list-select>
  </div>
</div>
